import {
  IonButtons,
  IonTitle,
  IonContent,
  IonHeader,
  IonPage,
  IonToolbar,
  IonBackButton,
  useIonViewWillEnter,
  IonButton,
  IonItemDivider,
  IonLabel,
  IonCol,
  IonGrid,
  IonRow,
} from "@ionic/react";
import React from "react";
import { useDispatch } from "react-redux";
import { findLocations } from "../../store/locations/actions/findLocations";
import { FilterSection } from "./components/FilterSection";
import { ListSection } from "./components/ListSection";
import { LocationsCount } from "./components/LocationsCount";
import { SearchTextInput } from "./components/SearchTextInput";
import { SortSelector } from "./components/SortSelector";
import { ViewModeSelector } from "./components/ViewModeSelector";

export const LocationsList: React.FC = () => {
  const dispatch = useDispatch();

  useIonViewWillEnter(() => {
    dispatch(findLocations());
  });

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton color="light" defaultHref="/app/rrhh" />
          </IonButtons>
          <IonTitle>Instalaciones</IonTitle>
          <IonButtons slot="end">
            <IonButton routerLink="/app/tic/instalaciones/nuevo">Nuevo</IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonGrid className="ion-padding-horizontal">
          <IonRow>
            <IonCol size="12" sizeMd="8" sizeLg="6">
              <SearchTextInput />
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonGrid className="ion-padding-horizontal">
          <IonRow class="ion-align-items-center">
            <IonCol size="auto" style={{ display: "flex" }}>
              <FilterSection />
            </IonCol>
          </IonRow>
        </IonGrid>

        <section className="ion-padding-horizontal">
          <IonItemDivider class="ion-margin-bottom">
            <IonLabel>
              <h2>
                <LocationsCount />
              </h2>
            </IonLabel>
            <IonButtons slot="end">{/* <SortSelector /> */}</IonButtons>
          </IonItemDivider>
        </section>

        <IonGrid className="ion-padding-horizontal">
          <IonRow class="ion-align-items-center">
            <IonCol size="12" sizeLg="11">
              <ListSection />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};
